import type { OptionInterface } from '@components/types';

type GenericEnum = Record<string, string>;

export function getEnumKeyByValue(data: GenericEnum, value: string): string | null {
    const country = Object.keys(data).find((key) => {
        if (data[key] === value) {
            return key;
        }
    });

    return country ?? null;
}

export function enumToOptions(data: GenericEnum, sortOptions = false): OptionInterface<string>[] {
    let options = Object.entries(data).map((countryEntry) => ({
        value: countryEntry[1],
        text: countryEntry[0],
    }));

    if (sortOptions) {
        options = options.sort((a, b) => {
            if (a.text < b.text) {
                return -1;
            }

            if (a.text > b.text) {
                return 1;
            }

            return 0;
        });
    }

    return options;
}
